import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import SideBar4 from '../../components/Sidebar/SideBar4';
import useFetchCauseCategories from '../../hooks/fetchCauseCategories';
import { message, Switch, Select, Form, Input, DatePicker, InputNumber } from 'antd';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import useFetchOrganizations from '../../hooks/fetchOrganizations';
import { app } from '../../config';
import { LeftCircleOutlined } from '@ant-design/icons';
import { getTokenfromUserObj } from '../../utils/getTokenfromObj';
import getTerminalsByOrg from '../../hooks/getTerminalsByOrg';
console.log(app);
const { TextArea } = Input;
const AddKiosk = () => {
  const { t } = useTranslation(['common']);
  const [uploadObj, setUploadObj] = useState({});
  const [addUserResp, setAddUserResp] = useState({});
  const [show, setShow] = useState(false);
  let [isError,setIsError]=useState(false);
  const [org,setOrg]=useState('')
  const [terminals, setTerminals] = useState([]);
  const [connType, setconnType] = useState('');
  let navigate = useNavigate();
  let user = JSON.parse(localStorage.getItem('user'));
  const orgResp = useFetchOrganizations();
  const orgs = orgResp.response ? orgResp.response.data : [];
  console.log(user);


  useEffect(()=>{
    const getData=async(id)=>{
      try {
      console.log("organizaiton id ",id);
      const res = await axios.post(`${app.URL}/merchantportal/terminals`,{organizationId:id},{headers:{auth:token}});
      res?console.log(res.data.data):" ";
      console.log(typeof(res.data.data));
      res&&res.data.data[0]?setTerminals(res.data.data):setTerminals([]);
    } catch (err) {
      console.log(err)
    }

    }
    getData(org);
  }, [org]);
 
  // const roleResp=useFetchRoles();
  // console.log(roleResp);
  // const roles=roleResp.response?roleResp.response.data:[];
  // console.log(roles);
  const token = getTokenfromUserObj();
  const uploadData = async (uploadObj) => {
    try {
      console.log(uploadObj);
      const res = await axios.post(`${app.URL}/kiosk/add`, uploadObj, { headers: { auth: token } });
      console.log("response", res)
     
      setAddUserResp(res.data);
      setTimeout(() => {
        navigate('/kiosk/view');
      }, 1000);

    } catch (err) {
      console.log(err);
      if (err) {
        // console.log("response: ", res)

        setShow(false)
        message.error(err?.response?.data?.message);
      }
      else retrun;
    }
  };
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const onFinish = (values) => {
    console.log('Success:', values);
    // o={...values}
    // console.log(values.validityDate.format().split('T')[0]);
    setUploadObj({
      kioskRef: values.kioskRef ? values.kioskRef : null,
      name: values.name ? values.name : null,
      model: values.model ? values.model : null,
      isActive: values.isActive === true ? 1 : 0,
      connectionType: values.connectionType?values.connectionType : null,
      mechanism:values.mechanism?values.mechanism:null,
      sessionTimer:values.sessionTimer ? values.sessionTimer:0,
      terminalId: values.terminalId ? values.terminalId : null,
      organizationId: values.organizationId ? values.organizationId : null,
      organizationContent: values.organizationContent ? values.organizationContent : null,
      adminContent: values.adminContent ? values.adminContent : null,
      launchDate: values.launchDate ? values.launchDate.format().split('T')[0] : '',
      createdByUserId: user.userId,
    });
    setShow(true);
  };
  console.log("Success2",uploadObj);
  const submitData = () => {
    console.log('calling');


    if (Object.keys(uploadObj).length > 0) {
      uploadData(uploadObj);
    }

    
  };
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
  const c = useFetchCauseCategories();
  console.log(c);
  let causes = c ? c.response : [];
  console.log(causes);
  function goBack() {
    navigate('/kiosk/view', { replace: true });
  }
  window.addEventListener('popstate', goBack);
  console.log(org)
  let connectionType=[{
    typeId:1,
    name:'Bluetooth'
  },{
    typeId:2,
    name:'USB'
  },

]
let mechanism=[{
  typeId:1,
  name:'mxmTerminal'
},{
  typeId:2,
  name:'chipper'
},
  ]
  console.log("mechtype", connType)
  return (
    <div class='container'>
      <div class='row mt-4 w-75 tbl'>
        <div class='row topbar ' style={{ height: '70px' }}>
          <div class='col-lg-4 fs-3 fw-bold'>
            {' '}
            <LeftCircleOutlined
              onClick={() => {
                navigate('/kiosk/view');
              }}
              className='mt-3 ml-4 back-icon'
              style={{ fontSize: '38px' }}
            />
          </div>
          <div class='col-lg-7 fs-3 fw-bold '>
            <h2 class=' mb-5 mt-4 fw-bold text-white fs-4 ml-4'> {t('Add Kiosk')} </h2>
          </div>{' '}
        </div>
        <div class='col mb-5 w-50'>
          <div class='col-lg-9 align-self-center mt-4 mb-4'>
            <Form
              name='basic'
              labelCol={{
                span: 8,
              }}
              wrapperCol={{
                span: 16,
              }}
              style={{
                maxWidth: 600,
              }}
              initialValues={{
                remember: true,
                ['id']: 1,
                ['causename']: 'Hammad',
                ['isActive']: true,
                // ['bluetoothDevice']: true,

              }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete='off'
            >
              {/* Select box for Organization */}
              <Form.Item
                colon={false}
                label='Organization'
                name='organizationId'
                rules={[
                  {
                    required: true,
                    message: 'Select Organization',
                  },
                ]}
              >
                <Select
                  style={{
                    width: 280,
                  }}
                  placeholder='Select Organization'
                  onChange={(value)=>{setOrg(value)}}
                >
                  {orgs
                    ? orgs.map((org) => {
                        return (
                          <Option key={org.organizationId} value={org.organizationId}>
                            {org.organizationName}
                          </Option>
                        );
                      })
                    : ' '}
                </Select>
              </Form.Item>
              <Form.Item
                label='Serial Number'
                name='kioskRef'
                // defaultValue='1'
                colon={false}
                rules={[
                  {
                    required: true,
                    message: 'Enter Reference Number',
                  },
                ]}
              >
                <Input placeholder='Enter Reference Number' />
              </Form.Item>
              <Form.Item
                label='Name'
                name='name'
                // defaultValue='1'
                colon={false}
                rules={[
                  {
                    required: true,
                    message: 'Enter Kiosk Name',
                  },
                ]}
              >
                <Input placeholder='Enter Kiosk Name' />
              </Form.Item>
              <Form.Item
                colon={false}
                label='Model'
                name='model'
                rules={[
                  {
                    required: true,
                    // type:'email',
                    message: 'Enter Model Number',
                  },
                ]}
              >
                <Input placeholder='Enter Model Number' />
              </Form.Item>
              <Form.Item
                colon={false}
                label='Idle Time (seconds)'
                name='sessionTimer'
                rules={[
                  {
                    required: true,
                    // type:'email',
                    message: 'Enter Time to screen change(seconds)',
                  },
                ]}
              >
                
                <InputNumber style={{width: '47%'}} type='number' placeholder='Time in sec' />
              </Form.Item>
              {org ? <Form.Item
                colon={false}
                label='Terminal'
                name='terminalId'
                rules={[
                  {
                    required: true,
                    message: 'Select Terminal',
                  },
                ]}
              >
                <Select
                  style={{
                    width: 280,
                  }}
                  placeholder='Select Organization'
                >
                  {terminals.map((value) => {
                        return (
                          <Option key={value.iid} value={value.id}>
                            {value.name} ({value.description})
                          </Option>
                        );
                      })
                    }
                </Select>
              </Form.Item> :" "} 
              <Form.Item
                colon={false}
                label='Launch Date'
                name='launchDate'
                rules={[
                  {
                    required: true,
                    message: 'Please select Launch date',
                  },
                ]}
              >
                <DatePicker />
              </Form.Item>
              <Form.Item label='Active' colon={false} valuePropName='checked' name='isActive'>
                <Switch />
              </Form.Item>
              <Form.Item label='Mechanism' colon={false} valuePropName='mechanism' name='mechanism'>
              <Select
                  style={{
                    width: 280,
                  }}
                  placeholder='Select Connection Type'
                  onChange={(value)=>{setconnType(value)}}
                  // defaultValue={"mxmTerminal"}
                >
                  {mechanism
                    ? mechanism.map((mechanism) => {
                        return (
                          <Option key={mechanism.typeId} value={mechanism.name}>
                            {mechanism.name}
                          </Option>
                        );
                      })
                    : ' '}
                </Select>
              </Form.Item>

              {connType && connType == 'chipper' && 
                <Form.Item label='Connection Type' colon={false} valuePropName='connectionType' name='connectionType'>
                  <Select
                    style={{
                      width: 280,
                    }}
                    placeholder='Select Connection Type'
                    onChange={(value) => { setOrg(value) }}
                  // defaultValue={""}
                  >
                    {connectionType
                      ? connectionType.map((conn) => {
                        return (
                          <Option key={conn.typeId} value={conn.name}>
                            {conn.name}
                          </Option>
                        );
                      })
                      : ' '}
                  </Select>
                </Form.Item>


                
              }
             

              <Form.Item
                wrapperCol={{
                  offset: 8,
                  span: 16,
                }}
              >
                {addUserResp.statusCode === 200 ? (
                  <Modal show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                      <Modal.Title className='text-center'>Success</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>{addUserResp.message}</Modal.Body>
                    <Modal.Footer></Modal.Footer>
                  </Modal>
                ) : addUserResp.statusCode === 400 ? (
                  <Modal show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                      <Modal.Title className='text-center'>Failed</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>{addUserResp.data.message}</Modal.Body>
                    <Modal.Footer></Modal.Footer>
                  </Modal>
                ) : (
                  <Modal show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                      <Modal.Title>Confirmation</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>Are you sure you want to add Kiosk?</Modal.Body>
                    <Modal.Footer>
                      <Button variant='secondary' onClick={handleClose}>
                        Cancel
                      </Button>
                      <Button variant='primary' htmlType='submit' onClick={submitData}>
                        Save Changes
                      </Button>
                    </Modal.Footer>
                  </Modal>
                )
                }
                <button type='primary' class='btn btn-primary button' htmlType='submit'>
                  Add
                </button>
              </Form.Item>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddKiosk;
